// Événements mis en avant sous le hero — vider le tableau pour masquer le bandeau.
export const events = [
  {
    date: "16.11.2026",
    time: "10:30 – 12:30",
    city: "Gosselies (Hainaut)",
    url: "https://semainedelatransmission.be/fr/evenements/bien-valoriser-et-ceder-son-entreprise-en-toute-securite-lavenir-de-votre-patrimoine-professionnel-et-prive-impact-de-la-taxation-des-plus-values/",
  },
  {
    date: "17.11.2026",
    time: "10:30 – 12:30",
    city: "Liège",
    url: "https://semainedelatransmission.be/fr/evenements/bien-valoriser-et-ceder-son-entreprise-en-toute-securite-lavenir-de-votre-patrimoine-professionnel-et-prive-impact-de-la-taxation-des-plus-values-2/",
  },
];
